<div>
  <div>
    <h1 class="large">Социальная сеть для любителей кальяна</h1>
  </div>
  <div>
    <div>
      <img src="images/home/dialog.png" alt="dialog">
      <h2>Делитесь опытом</h2>
      <p>Размещайте фото, обзоры и советы</p>
    </div>
    <div>
      <img src="images/home/people.png" alt="people">
      <h2>Объеденяйтесь с энтузиастами</h2>
      <p>Подписывайтесь на пользователей и учавствуйте в обсуждениях</p>
    </div>
    <div>
      <img src="images/home/star.png" alt="star">
      <h2>Пробуйте новые вкусы</h2>
      <p>Иследуйте миксы и оценивайте</p>
    </div>
  </div>
</div>

